export default {
    pollingInterval: 8192,
    //pollingInterval: 30720,
    isCloseToStoreDistance: 300,
};
